import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import StepRoutes from "../../../Routes/steps_routes";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import performRequest from "../../../api/request";
import { Form, Formik } from "formik";
import Footer from "../../../Components/Footer/footer";
import { useSelector } from "react-redux";
import LoadingPage from "../../../Components/layouts/loading";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcClapperboard, FcCompactCamera, FcFilmReel } from "react-icons/fc";
import CustomSelect from "../../../CustomComponent/custom_select";
import { informativeVideoInfo } from "../../../SchemaInfo/info";
import { informativeVideoSchema } from "../../../Schemas/Media And Marketing/informative_video.schema";
import { useParams } from "react-router-dom";
import { useEffect } from "react";

const EditInformativeVideo = () => {
  const store = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  let { id } = useParams();
  const [informativeVideo, setInformativeVideo] =
    useState(informativeVideoInfo);
  const [socialMedia, setSocialMedia] = useState([]);

  const handelSubmit = (values) => {
    setLoading(true);
    let formData = new FormData();
    for (let key in values) {
      formData.append(key, values[key]);
    }
    const headers = { "Content-Type": "multipart/form-data" };
    performRequest("PATCH", `/informative-video/update/${id}`, values, headers)
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Informative Video Updated successfully!");
          navigate(`/informative-video/${id}`);
        } else {
          Toast("error", "Error while updating informative video");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/informative-video/getinformativeVideo/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setInformativeVideo(res.data);
          // console.log(buyersManagementInfo);
        } else {
          Toast("error", "Error while getting Lead!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/podcast/social-media-users`)
      .then((res) => {
        if (res.status === 200) {
          setSocialMedia(res.data);
          // console.log(buyersManagementInfo);
        } else {
          Toast("error", "Error while getting social media!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcFilmReel></FcFilmReel> Informative Video
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">Edit Informative Video</h2>
            </div>
            <Formik
              initialValues={informativeVideo}
              validationSchema={informativeVideoSchema}
              onSubmit={handelSubmit}
              enableReinitialize={true}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    <h3> Planning Informative Video</h3>
                    <hr className=""></hr>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Branding Assets
                      </label>
                      <div className="w-100 col">
                        <CustomSelect
                          name="videoBranding"
                          className="form-control"
                        >
                          <option value="">Select</option>
                          <option value="Kryzen Biotech">
                            Kryzen Biotech{" "}
                          </option>
                          <option value="Hydroponic Masterclass">
                            Hydroponic Masterclass
                          </option>
                          <option value="Sudhir Devkar">Sudhir Devkar</option>
                          <option value="Eat Pure Greens">
                            Eat Pure Greens
                          </option>
                        </CustomSelect>

                        {props.touched.videoBranding &&
                          props.errors.videoBranding && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.videoBranding}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Video Language
                      </label>
                      <div className="w-100 col">
                        <CustomSelect
                          name="videoLanguage"
                          className="form-control"
                        >
                          <option value="">Select Language</option>
                          <option value="Hindi">Hindi</option>
                          <option value="Marathi">Marathi</option>
                          <option value="English">English</option>
                        </CustomSelect>

                        {props.touched.videoLanguage &&
                          props.errors.videoLanguage && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.videoLanguage}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <hr></hr>
                    <h3>Video Shooting </h3>
                    <hr></hr>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Video Venue
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          className="form-control"
                          name="videoVenue"
                        ></CustomInput>
                        {props.touched.videoVenue &&
                          props.errors.videoVenue && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.videoVenue}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Shooting Date
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"date"}
                          className="form-control"
                          name="shootingDate"
                        ></CustomInput>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">
                        Camera Name / Lens name
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          className="form-control"
                          name="cameraName"
                        ></CustomInput>
                        {props.touched.cameraName &&
                          props.errors.cameraName && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.cameraName}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">
                        Raw Footage Folder Path
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          className="form-control"
                          name="rawFootagePath"
                        ></CustomInput>
                        {props.touched.rawFootagePath &&
                          props.errors.rawFootagePath && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.rawFootagePath}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">
                        Video Credits
                      </label>
                      <div className="w-100 col">
                        <CustomTextArea
                          type={"text"}
                          className="form-control"
                          name="videoCredit"
                        ></CustomTextArea>
                        {props.touched.videoCredit &&
                          props.errors.videoCredit && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.videoCredit}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <hr className=""></hr>
                    <h3> Video Editing</h3>
                    <hr className=""></hr>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Editor Name
                      </label>
                      <div className="w-100 col">
                        {/* <CustomInput
                       type={"text"}
                       className="form-control"
                       name="podcastEditor"
                     ></CustomInput> */}

                        <CustomSelect name="videoEditor">
                          <option value="">Select</option>
                          {socialMedia?.map((item, index) => {
                            return (
                              <option key={index} value={item?.userName}>
                                {item?.userName}
                              </option>
                            );
                          })}
                        </CustomSelect>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Deadline</label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"date"}
                          className="form-control"
                          name="taskdedline"
                        ></CustomInput>
                      </div>
                    </div>

                    {/* <div className="mb-3 row">
                   <label className="w-25 form-label col-3 ">
                     Video Script
                   </label>
                   <div className="w-100 col">
                     <CustomTextArea
                       type={"text"}
                       className="form-control"
                       name="videoScript"
                     ></CustomTextArea>
                     {props.touched.videoScript &&
                       props.errors.videoScript && (
                         <p className="text-danger">
                           {" "}
                           {props.errors.videoScript}{" "}
                         </p>
                       )}
                   </div>
                 </div> */}

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Comming Soon Poster
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name=""
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "commingSoonPoster",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.commingSoonPoster &&
                          props.errors.commingSoonPoster && (
                            <p className="text-danger">
                              {props.errors.commingSoonPoster}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Video Thumbnail
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name=""
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "videoThumbnail",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.videoThumbnail &&
                          props.errors.videoThumbnail && (
                            <p className="text-danger">
                              {props.errors.videoThumbnail}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">
                        Video First Draft File Path
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          className="form-control"
                          name="videofirstPath"
                        ></CustomInput>
                        {props.touched.videofirstPath &&
                          props.errors.videofirstPath && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.videofirstPath}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <hr></hr>
                    <h3>Final </h3>
                    <hr></hr>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Final Footage Path
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"text"}
                          className="form-control"
                          name="videoDriveLink"
                        ></CustomInput>
                        {props.touched.videoDriveLink &&
                          props.errors.videoDriveLink && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.videoDriveLink}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Publish Title
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          className="form-control"
                          name="videoTitle"
                        ></CustomInput>
                        {props.touched.videoTitle &&
                          props.errors.videoTitle && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.videoTitle}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">
                        Publish Description
                      </label>
                      <div className="w-100 col">
                        <CustomTextArea
                          type={"text"}
                          className="form-control"
                          name="videoDescription"
                        ></CustomTextArea>
                        {props.touched.videoDescription &&
                          props.errors.videoDescription && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.videoDescription}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Mark as Published (Upload proof)
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name=""
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "markAsPublished",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.markAsPublished &&
                          props.errors.markAsPublished && (
                            <p className="text-danger">
                              {props.errors.markAsPublished}
                            </p>
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Edit Informative Video" />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};
export default EditInformativeVideo;
